import { createFileRoute } from "@tanstack/react-router";
import { attendanceSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/attendance/")({
  head: () => ({
    meta: [{ title: "考勤记录 · imiker CRM" }],
  }),
  validateSearch: attendanceSearchSchema
});
